<template>
  <div>
      <b-table 
        head-variant="light"
        @row-clicked="myHandler"
        ref="general-table"
        class="vuetable"
        id="noticeNo"
        :totalsNum="totalsNum"
        :items="items"
        align="center"
        :fields="fields"
        :isSizePnotice="isSizePnotice"
        :isNumPnotice="isNumPnotice"
        :per-page="0"
        :current-page="currentPage"
        primary-key="noticeNo"
        show-empty
        empty-text="내용이 없습니다."
      >
      <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.key === '제목' ? '90%' : '10%' }"
        >
      </template>
        <template v-slot:cell(noticeNo)="row">
              <span class="trRow" v-if="!row.item.importantFlag">
                   {{ totalsNum - (isSizePnotice * isNumPnotice + row.index)  }}
              </span>
              <span class="nCaption" v-else>
                  중요
              </span>
        </template>
        <template v-slot:cell(registeredBy)="row">
              <span class="trRow">
                  {{ row.item.registeredBy }}
              </span>
        </template>
        <template v-slot:cell(title)="row">
              <span class="trRow">
                  {{ row.item.title }}
              </span>
        </template>
        <template v-slot:cell(registeredDate)="row">
              <span class="trRow">
                  {{ row.item.registeredDate.substr(0, 10) }}
              </span>
        </template>
        
      </b-table>
  </div>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";
export default {
    data(){
        return{
            indexNum: 0
        }
    },
    props: ['items', 'fields', 'currentPage', 'perPage','totalsNum','isSizePnotice','isNumPnotice'],
    computed: {
        ...mapGetters(['currentUser', 'siteName']),
        // indexN: function(){
        //     for (let i = 0; i < this.totalsNum; i++) {
        //         this.indexNum++
        //         console.log(this.indexNum)
        //         return this.indexNum
        //     }
        //     return this.indexNum
        // }
    },
    methods:{
         myHandler: function(item, index, event){
            this.$router.push('/'+this.siteName+'/notice/NoticeDetail?query='+item.id);
        },
        startNum(){
            return (this.isSizePnotice - 1) * this.isNumPnotice;
        }
    }
}
</script>

<style>
table#noticeNo tr {
    cursor: pointer;
}
span.nCaption {
    color: #fff;
    background: #c11314;
    border-radius: 5px;
    padding: 5px;
}
</style>